<template>
  <fragment>
    <Title>{{activityName}}</Title>
    <div :key="index" v-for="(item,index) in infoObj.list">
      <HomeBase :info="infoObj.homeBase"
        v-if="(['grid', 'diyGrid'].includes(item.tag) || pageType == 6) && (infoObj.homeBase && infoObj.homeBase.loadingTitle)" />
      <EndBase :info="infoObj.endBase"
        v-if="(['grid', 'diyGrid'].includes(item.tag) || pageType == 6) && (infoObj.endBase && infoObj.endBase.statusShow)" />
      <Affix :info="item" :activityId="activityId" :activityType="pageType" @handleAffixClick="handleAffixClick"
        v-if="item.tag=='affix'" />
      <Popup :info="item" v-else-if="item.tag=='popup'" @close="close" :show-popup="showPopup" />
      <Audio :info="item" :activityId="activityId" :activityType="pageType" @handleAudioClick="handleAudioClick"
        v-else-if="item.tag=='audio'" />
      <Video :info="item" :activityId="activityId" :activityType="pageType" v-else-if="item.tag=='video'" />
      <Grid :activityId="activityId" :activityStatus="activityStatus" :activityType="pageType" :openId="openId"
        :info="item" :base="infoObj.homeBase" :showRules="showRules" v-else-if="item.tag=='grid'"
        @handleGridClick="handleGridClick" />
      <DiyGrid :activityId="activityId" :activityStatus="activityStatus" :activityType="pageType" :openId="openId"
        :info="item" :base="infoObj.homeBase" :showRules="showRules" v-else-if="item.tag=='diyGrid'"
        @handleGridClick="handleGridClick" />
      <Ranking :activityId="activityId" :activityType="pageType" :openId="openId" :info="item"
        :activityStatus="activityStatus" v-else-if="item.tag=='ranking'" />
      <Cimage :info="item" :activityId="activityId" :activityType="pageType" v-else-if="item.tag=='img'" direction="row"
        @handleImgClick="handleImgClick" />
    </div>
  </fragment>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
import { getQueryString } from "@/utils/utils";
import { loadScript, encodeSearchParams } from "@/utils/utils";
export default {
  name: "Home",
  computed: {},
  data() {
    return {
      openId: "",
      userId: "",
      enterSource: "",
      activityStatus: "",
      infoObj: {},
      showPopup: true,
      activityName: "",
      activityId: "",
      pageNo: "",
      pageType: undefined, // 活动类型
      showRules: true,  // 是否展示活动规则
      test: '', // 是否测试环境
    };
  },
  provide() {
    return {
      getEnterSource: () => this.enterSource
    };
  },
  mounted() {
    if (this.$route.path.indexOf('other') != -1) {
      this.showRules = false
    }
    this.activityId = getQueryString("activityId");
    this.pageNo = getQueryString("pageNo");
    this.openId = getQueryString("openId");
    this.userId = getQueryString("userId");
    this.enterSource = getQueryString("enterSource")
    this.test = getQueryString("test")
    if (this.openId) {
      localStorage.setItem("openId", this.openId)
    }
    if (this.userId) {
      localStorage.setItem("userId", this.userId)
    }
    this.getPageConfig().then(id => {
      this.pageInitPoint()
    });
  },
  methods: {
    // 获取配置项
    getPageConfig() {
      return new Promise((resolve, reject) => {
        let params = {
          activityId: this.activityId,
          openId: this.openId,
          pageNo: this.pageNo,
          test: this.test
        };
        this.$ebLoading.show();
        this.$fetch(
          { url: "/ehs/activity/page/config", method: "post" },
          params
        ).then(res => {
          this.$ebLoading.hide();
          if (res.success) {
            this.infoObj = {};
            setTimeout(() => {
              this.infoObj = JSON.parse(res.model.pageContent);
              this.activityStatus = res.model.activityStatus;
              this.activityName = res.model.activityName;

            }, 300);
            this.pageType = res.model.pageType
            resolve(res.model.talkingDataAppId);
          } else {
            if (res.errorCode == "CLA100077") {
              console.log("没有页面");
              return;
            }
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        }).finally(() => {
          this.$ebLoading.hide();
        })
      });
    },
    pageInitPoint() { // 页面初始化打点
      this.$log.senLog({
        pointID: '12010001',
        eventType: 1,
        businessData: {
          enterSource: this.enterSource || '',
          activityType: this.pageType !== undefined ? this.pageType : '',
          activityId: this.activityId || '',
          appSource: isMiniApplets() ? isMiniApplets() : '',
        }
      })
    },
    close(val) {
      this.showPopup = val;
    },
    // 热区点击操作统一跳转
    hotAreaHandleClick(val) {
      if (val.jumpType == 2) {
        this.pageNo = val.urlPath;
        this.getPageConfig();
      } else if ([3, 4].includes(val.jumpType)) {
        this.urlFor(val);
      } else if (val.jumpType == 1) {
        // alert("无");
      }
    },
    // 热区点击操作统一跳转、九宫格、图片组件
    hotAreaHandleClickNew(val) {
      console.info(val)
      let res = ''

      if (val.beCommonClick) {
        res = val.clickForwardConfig || {}
      } else {
        let isMiniApp = isMiniApplets()
        let data = val.interactiveAnotherList || ''

        if (data) {
          if (isMiniApp === 'wechat' && data[0].platform === 1) {
            res = data[0].clickForwardConfig
          }
          if (isMiniApp === 'alipay' && data[1].platform === 0) {
            res = data[1].clickForwardConfig
          }
          if (isMiniApp === 'eleme' && data[2].platform === 2) {
            res = data[2].clickForwardConfig
          }
        } else {
          res = val
        }
      }

      if (res.jumpType == 2) {
        this.pageNo = res.urlPath;
        this.getPageConfig();
      } else if ([3, 4].includes(res.jumpType)) {
        this.urlFor(res);
      } else if (res.jumpType == 1) {
        // alert("无");
      } else if (res.jumpType == 6) {
        this.handleCopy(res.urlPath)
      }else if (res.jumpType == 7) { //请求手机号
        let urlPathUsed = res.urlPath
        if (urlPathUsed.indexOf('?') == -1) {
          urlPathUsed += `?`
        }else{
          urlPathUsed += `&`
        }
        this.aesPhone((aesPhone)=>{
          urlPathUsed += `aesPhone=${aesPhone}`
          res.urlPath = urlPathUsed
          this.urlFor(res)
        })
      }
    },
    // 查询加密手机号
    aesPhone(callBack){
      //是否有openId   
      if(!this.openId ||  this.openId == 'undefined'){
        callBack('')
        return
      }
      let params = {
          activityId: this.activityId,
          openId: this.openId
        };
      this.$fetch(
          { url: "/ehs/activity/aes-phone", method: "post" },
          params
        ).then(res => {
          if (res.success) {
            let model = res.model || {}
            let {
                aesPhone=''
            } = model
            callBack(aesPhone)
          } 
        })
    },
    // 九宫格点击
    handleGridClick(val) {
      this.hotAreaHandleClickNew(val)
    },
    // 固钉点击操作
    handleAffixClick(val) {
      this.hotAreaHandleClick(val);
    },
    // 音频热区点击操作
    handleAudioClick(val) {
      this.hotAreaHandleClick(val);
    },
    // 图片区域点击操作
    handleImgClick(val) {
      this.hotAreaHandleClickNew(val);
    },
    handleCopy(val) {
      this.$copyText(val).then(
        res => {
          this.toast('复制成功')
        },
        err => {
          this.toast('复制出错')
        }
      );
    },

    toast(txt) { // 错误提示
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: txt,
        duration: 3000
      })
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
